exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color[data-v-99ddefb6] {\n  width: 40px;\n  height: 40px;\n}\n.color.active[data-v-99ddefb6] {\n    border-color: #4f4f4f;\n}\n.color-inside[data-v-99ddefb6] {\n  width: 34px;\n  height: 34px;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
